<template lang="pug">
  DataTablePage(
    ref="tablePage"
    mainColumn="name"
    longColumn="remark"
    resource="rbac/user"
    title="用户管理"
    label="用户"
    labelName="loginName"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth="150"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :createList="createList"
    :updateList="updateList"
    :createFormValues="createFormValues"
    :columnGroupBy="columnGroupBy"
    :columns="columns")
    SmartDialog(
      v-if="resetDialogShow"
      v-model="resetDialogVisible"
      size="md"
      :title="resetDialogLabel")
      SmartForm(
        class="dialogform"
        :formList="resetList"
        :columns="columns"
        :values="resetDialogFormValues"
        :buttonList="resetButtonList")
</template>

<script>
import SmartDialog from '@/components/SmartDialog'
import DataTablePage from '@/containers/DataTablePage'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
import { operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'
import SmartForm from '@/components/SmartForm'
import { fetchUpdate } from '@/utils/api'

function operationEventReset ({funcProps}) {
  const { data, account } = funcProps
  account.resetDialogId = data.id
  account.resetDialogLabel = '重置密码' + '【' + data.loginName + '】'
  account.resetDialogVisible = true
  account.resetDialogFormValues = {}
}

export default {
  name: 'account',
  components: {
    SmartDialog,
    DataTablePage,
    SmartForm
  },
  data () {
    const hasUpdate = checkActions('/system/account/update')
    const hasDelete = checkActions('/system/account/delete')
    const hasReset = checkActions('/system/account/resetPassword')
    return {
      toolbar: [{
        ...toolbarCreate,
        isShow () {
          return checkActions('/system/account/create')
        }
      }],
      operation: [{
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        }
      }, {
        name: 'reset',
        label: '重置密码',
        icon: 'password',
        tooltip: true,
        funcProps: {
          account: this
        },
        func: operationEventReset,
        isShow () {
          return hasReset
        }
      }],
      tableInitList: ['id', 'loginName', 'jobNumber', 'name', 'orgId', 'roleIds', 'linkTel', 'linkPhone', 'enabled', 'remark'],
      tableFullList: ['id', 'loginName', 'jobNumber', 'name', 'orgId', 'roleIds', 'linkTel', 'linkPhone', 'enabled', 'remark'],
      filterInitList: ['loginName', 'jobNumber', 'name'],
      filterFullList: ['loginName', 'jobNumber', 'name'],
      createList: ['loginName', 'jobNumber', 'loginPassword', 'name', 'orgId', 'linkTel', 'linkPhone', 'enabled', 'remark', 'roleIds'],
      updateList: ['name', 'jobNumber', 'orgId', 'linkTel', 'linkPhone', 'enabled', 'remark', 'roleIds'],
      resetDialogVisible: false,
      resetDialogLabel: '重置密码',
      resetList: ['newPassword'],
      resetButtonList: [{
        name: 'reset',
        label: '重置密码',
        icon: 'key',
        funcProps: {
          account: this
        },
        func ({funcProps}) {
          const { form, account } = funcProps
          fetchUpdate({
            resource: 'rbac/user/resetPassword',
            id: account.resetDialogId,
            data: {
              newPassword: form.formValues.newPassword
            }
          })
          .then(data => {
            account.$refs.tablePage.getData()
            account.resetDialogVisible = false
          })
        }
      }],
      resetDialogFormValues: {
        newPassword: ''
      },
      createFormValues: {
        loginName: '',
        loginPassword: '',
        name: '',
        roleIds: [],
        enabled: true,
        remark: ''
      },
      columns: {
        id: {
          label: 'ID',
          width: 60
        },
        loginName: {
          label: '账号',
          width: 100,
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入账号'
            }]
          }
        },
        jobNumber: {
          label: '工号',
          width: 100,
          sort: true,
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入工号'
            }]
          }
        },
        loginPassword: {
          label: '密码',
          form: {
            type: 'password',
            rules: [{
              type: 'required',
              message: '请输入密码'
            }]
          }
        },
        newPassword: {
          label: '新密码',
          form: {
            type: 'password',
            rules: [{
              type: 'required',
              message: '请输入密码'
            }]
          }
        },
        name: {
          label: '姓名',
          width: 120,
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入姓名'
            }]
          }
        },
        orgId: {
          label: '所属部门',
          width: 120,
          type: 'select',
          relation: 'orgs',
          filter: {
            type: 'cascader',
            live: true,
            onlySelectLeaf: false,
            placeholder: '请选择部门'
          },
          form: {
            type: 'cascader',
            live: true,
            onlySelectLeaf: false,
            placeholder: '请选择部门',
            rules: [{
              type: 'required',
              message: '请选择部门'
            }]
          }
        },
        roleIds: {
          label: '角色',
          type: 'multiselect',
          relation: 'roles',
          form: {
            type: 'select',
            multiple: true,
            live: true
          }
        },
        enabled: {
          label: '启用状态',
          width: 105,
          sort: true,
          type: 'select',
          relation: 'enabled',
          style: {
            textAlign: 'center'
          },
          filter: {
            type: 'select',
            width: 120
          },
          form: {
            type: 'select'
          }
        },
        title: {
          label: '头衔',
          form: {
            type: 'input'
          }
        },
        linkTel: {
          label: '联系电话',
          width: 120,
          minLength: 200,
          style: {
            textAlign: 'center'
          },
          filter: {
            width: 100,
            type: 'input'
          },
          form: {
            type: 'input'
          }
        },
        linkPhone: {
          label: '联系号码',
          style: {
            textAlign: 'center'
          },
          width: 100,
          minLength: 200,
          filter: {
            width: 100,
            type: 'input'
          },
          form: {
            type: 'input'
          }
        },
        email: {
          label: '电子邮箱',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input'
          }
        },
        phone: {
          label: '电话',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input'
          }
        },
        mobile: {
          label: '手机',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input'
          }
        },
        address: {
          label: '地址',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            large: true
          }
        },
        remark: {
          label: '备注',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            large: true,
            rules: [{
              type: 'maxLength',
              value: 120,
              message: '字数不能大于120个字'
            }]
          }
        },
        qq: {
          label: 'QQ',
          form: {
            type: 'input'
          }
        },
        nickname: {
          label: '昵称',
          form: {
            type: 'input'
          }
        },
        sex: {
          label: '性别',
          type: 'select',
          form: {
            type: 'select'
          }
        }
      },
      columnGroupBy: [{label: '基本信息', filter: ['id', 'loginName', 'name', 'roleIds', 'loginPassword', 'orgId', 'email', 'mobile']},
      {label: '公司信息', filter: ['roleIds', 'orgId']}]
    }
  },
  computed: {
    resetDialogShow () {
      return this.resetDialogVisible
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    resetPassword (data, props, full) {
      fetchUpdate({
        resource: props.account.$refs.tablePage.resource,
        id: full.id,
        data: data
      })
      .then(data => {
        props.account.$refs.tablePage.getData()
        props.account.resetDialogVisible = false
      })
    }
  }
}
</script>
<style scoped lang="sass">
.dialogform
  padding: 16px
</style>



// WEBPACK FOOTER //
// Account.vue?7dd110d6